module.exports = __webpack_public_path__ + "img/empty-table.4c6e4167.svg";